"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
function BlogGridConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {[...Array(3)].map((_, i) => <div key={i} data-index={i} className="flex flex-col gap-4 animate-pulse">
            <div className="w-full aspect-video bg-muted rounded-md" />
            <div className="h-4 w-24 bg-muted rounded" />
            <div className="h-6 w-3/4 bg-muted rounded" />
            <div className="h-4 w-20 bg-muted rounded mt-2" />
          </div>)}
      </div>;
  }
  if (error) {
    return <div className="text-center text-muted-foreground py-12">
        <p>An error occurred while loading community alerts.</p>
      </div>;
  }
  if (!posts || posts.length === 0) {
    return <div className="text-center text-muted-foreground py-12">
        <p>There are currently no active alerts or news updates.</p>
      </div>;
  }
  return <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {posts.map((post, i) => <article key={post.id} data-index={i} className="flex flex-col group border border-transparent hover:border-destructive/20 transition-colors rounded-md">
          <Link to={post.link || "#"} className="block overflow-hidden rounded-md mb-4 relative">
            <img src={post.featuredImage || "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689786/img/police_alert_placeholder.png"} alt={post.title} className="w-full aspect-video object-cover transition-transform duration-500 group-hover:scale-105" />
            <div className="absolute top-2 right-2 bg-primary text-primary-foreground px-2 py-1 text-xs font-mono rounded-md shadow-sm">
              {post.date ? new Date(post.date).toLocaleDateString('en-US', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
          }) : "LOGGED"}
            </div>
          </Link>
          <div className="flex flex-col flex-grow px-2 pb-4">
            <span className="text-xs text-secondary font-mono font-semibold uppercase tracking-wider mb-2">
              Official Bulletin
            </span>
            <Link to={post.link || "#"} className="block mb-3">
              <h3 className="text-xl font-default font-bold text-foreground group-hover:text-secondary transition-colors line-clamp-2">
                {post.title}
              </h3>
            </Link>
            <div className="mt-auto pt-2">
              <Link to={post.link || "#"} className="inline-flex items-center gap-1 font-default font-bold text-sm text-primary hover:text-secondary transition-colors">
                VIEW FULL REPORT <ArrowRight className="w-4 h-4" />
              </Link>
            </div>
          </div>
        </article>)}
    </div>;
}
export default function CommunityWatchAlerts() {
  const wp_query_params = {
    post_type: "post",
    per_page: 3,
    orderby: "date",
    order: "desc"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section data-section-id="223439" id="community-watch-alerts" className="bg-background text-foreground py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-12 text-center md:text-left border-l-4 border-primary pl-6">
          <h2 className="text-3xl md:text-4xl font-default font-extrabold text-primary mb-4 tracking-tight uppercase">
            Community Watch & Alerts
          </h2>
          <p className="text-muted-foreground font-default text-lg max-w-2xl leading-relaxed">
            Stay informed with the latest public safety updates, criminal activity reports, and community initiatives from the Metropolitan Central Police.
          </p>
        </div>
        
        <PostsProvider wp_query={{
        post_type: "post",
        per_page: 3,
        orderby: "date",
        order: "desc"
      }}>
          <BlogGridConsumer />
        </PostsProvider>
      </div>
    </section>;
}